import React, { useEffect, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import Services from './Services';
import Footer from './Footer';
import './ServiceDetailPage.css';

const ServiceDetailPage = () => {
  const { serviceId } = useParams();

  // Map service ids to friendly titles used in Services section
  const titleMap = useMemo(() => ({
    'taxation': 'Taxation',
    'gst-hst': 'GST/HST Filing',
    'financial-planning-consultation': 'Financial Planning & Consultation',
    'incorporation': 'Business Incorporation',
    'bookkeeping': 'Bookkeeping Services',
    'wsib-filing': 'WSIB Filing',
    'payroll': 'Payroll Services',
  }), []);

  const heroImageMap = useMemo(() => ({
    'taxation': 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=1600&auto=format&fit=crop',
    'gst-hst': 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1600&auto=format&fit=crop',
    'financial-planning-consultation': 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1600&auto=format&fit=crop',
    'incorporation': 'https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?q=80&w=1600&auto=format&fit=crop',
    'bookkeeping': 'https://images.unsplash.com/photo-1554224154-22dec7ec8818?q=80&w=1600&auto=format&fit=crop',
    'wsib-filing': 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=1600&auto=format&fit=crop',
    'payroll': 'https://images.unsplash.com/photo-1521540216272-a50305cd4421?q=80&w=1600&auto=format&fit=crop',
  }), []);

  useEffect(() => {
    // Check if there's a hash in the URL and scroll to that section
    const hash = window.location.hash.replace('#', '');
    if (hash === 'tax-deadlines') {
      // Wait for the component to render, then scroll to tax deadlines
      const scrollToTaxDeadlines = () => {
        const element = document.getElementById('tax-deadlines');
        if (element) {
          // Calculate offset to account for fixed header
          const headerHeight = 120;
          const elementPosition = element.offsetTop - headerHeight;
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        } else {
          // If element not found, try again after a short delay
          setTimeout(scrollToTaxDeadlines, 100);
        }
      };
      
      // Start trying to scroll after a short delay
      setTimeout(scrollToTaxDeadlines, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Listen for hash changes
    const handleHashChange = () => {
      const newHash = window.location.hash.replace('#', '');
      if (newHash === 'tax-deadlines') {
        setTimeout(() => {
          const element = document.getElementById('tax-deadlines');
          if (element) {
            const headerHeight = 120;
            const elementPosition = element.offsetTop - headerHeight;
            window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, [serviceId]);

  const scrollToServices = () => {
    const el = document.getElementById('services');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="service-detail-page section">
      <div className="container">
        <nav className="detail-breadcrumbs">
          <Link to="/">Home</Link>
          <span>›</span>
          <a href="/#services" onClick={scrollToServices}>Services</a>
          <span>›</span>
          <span className="current">{titleMap[serviceId] || 'Service Details'}</span>
        </nav>

        <div className="detail-layout">
          <div className="detail-media">
            <img src={heroImageMap[serviceId]} alt={titleMap[serviceId]} />
          </div>
          <aside className="detail-aside">
            <div className="help-card">
              <h4>Ready to Get Started?</h4>
              <p>Let our GTA accounting experts handle your financial needs with personalized service and local expertise.</p>
              <a href="#contact" className="btn btn-primary">Contact Us</a>
            </div>
            <div className="aside-note">
              <p>Transform your financial stress into peace of mind with our proven track record of 500+ satisfied clients across the Greater Toronto Area.</p>
            </div>
          </aside>
        </div>

        {/* Reuse Services component with the desired tab active to keep content unchanged */}
        <Services initialTab={serviceId} variant="detail" />
      </div>
      <Footer />
    </section>
  );
};

export default ServiceDetailPage;

